<template>
  <div class="platform-container">
<!--    <div class="platform-header">-->
<!--      <h1>一站式算力交易和服务平台</h1>-->
<!--      <p>-->
<!--        算力无界，交易有方，让每个AI项目不缺算力-->
<!--      </p>-->

<!--    </div>-->

    <div class="platform-title-ui">
      <div class="title">
        <div class="platform-title">平台简介</div>
        <div class="platform-title-en">Platform Introduction</div>
      </div>
    </div>

    <div class="platform-content">
      <div class="platform-content-left">
        <img class="platform-content-left-img" src="../../assets/img/pingtaijieshao.jpg" alt="平台简介" />
      </div>
      <div class="platform-content-right">
        <div class="content-section">
          <h2>算力共享长三角，智创数字共同体</h2>
          <p>
            数字浪潮奔涌，算力驱动未来！长三角算力公共服务平台以“打造算力新生态，赋能区域新发展”为使命，深度融入长三角一体化战略，构建覆盖全域的智能算力服务体系。
          </p>
        </div>

        <div class="content-section">
          <h2>云端聚能新基建，智启创新增长极</h2>
          <p>
            以数字之力赋能未来，加速区域一体化高质量发展！以开放共享模式降低数字转型门槛，助力长三角建成全球领先的智能算力枢纽，携手迈向数字化共赢新时代！
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PlatformIndex",
  methods: {
    handleToPortal() {
      this.$router.push("/portal");
    },
  },
};
</script>

<style scoped lang="scss">
.platform-container {
  .platform-header {
    background: linear-gradient(to right, #1890ff, #096dd9);
    color: white;
    height: 220px;
    padding: 30px 241px;
    border-radius: 4px;
    margin-bottom: 66px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    background-image: url("../../assets/bg/xinwengbanner.png");
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;

    h1 {
      margin: 0;
      font-size: 48px;
    }

    p {
      margin: 29px 0 0;
      font-size: 16px;
      opacity: 0.8;
    }
  }

  .platform-title-ui {
    padding: 0 241px;
    display: flex;
    justify-content: center;
    align-items: flex-start;

    .left {
      display: flex;
      align-items: center;
      font-size: 16px;
      color: #000;
      cursor: pointer;
      width: 100px;

      .back-icon {
        margin-right: 2px;
        width: 16px;
        height: 16px;
      }
    }

    .right {
      width: 100px;
    }

    .title {
      margin-bottom: 30px;

      .platform-title {
        font-size: 36px;
        color: #333333;
        text-align: center;
      }

      .platform-title-en {
        font-weight: bold;
        font-size: 20px;
        color: #cdcdcd;
        text-align: center;
      }
    }
  }

  .platform-content {
    padding: 0 241px;
    display: flex;
    align-items: flex-start; /* 关键：图文顶部对齐 */
    gap: 30px; /* 替代margin，更优雅的间距控制 */
    margin-bottom: 40px;

    .platform-content-left {
      flex-shrink: 0;
      width: 372px;
      background-color: #cdcdcd;

      .platform-content-left-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        vertical-align: top; /* 解决图片底部多余空白问题 */
      }
    }
    .platform-content-right {
      flex: 1; /* 让文字容器自适应剩余宽度 */
    }
    .content-section {
      margin-bottom: 40px;

      h2 {
        font-size: 24px;
        color: #333;
        margin: 0 0 20px 0; /* 重置margin，确保顶部无多余间距 */
      }

      p {
        font-size: 16px;
        color: #666;
        line-height: 1.8;
        text-align: justify;
        margin: 0; /* 重置段落margin，避免默认间距影响 */
      }
    }
  }
}
</style>
